/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

import {ListItemHarness} from '../../../list/internal/listitem/harness.js';

/**
 * Test harness for menu item.
 */
export class SelectOptionHarness extends ListItemHarness {}
